exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control[type=email],.form-control[type=number],.form-control[type=password],.form-control[type=search],.form-control[type=tel],.form-control[type=text],.form-controltextarea{border-radius:5px;font-size:14px}.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.form-control-label{margin-bottom:.5rem;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7df756a6","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/inventory/pricebook/pricebook.vue
// module id = M5dF
// module chunks = 50